import Api from '@/services/Api'
const dormpath = 'studentdev/dormitory/';

export default {
  getAllGroup() {
    return Api().get(dormpath + "group/services");
  },
  getGroupStudent() {
    return Api().get(dormpath + "check/group/service").catch(function (error) {
      console.log(error.response.data);
    });
  },
  getStudentRegister() {
    return Api().get(dormpath + "booking/register");
  },
  /*getReserv(e) {
    return Api().get(dormpath + "admin/reservations" + e);
  },
  postReserv(data) {
    return Api().post(dormpath + "admin/reservations", data);
  },
  put(data) {
    return Api().put(dormpath + "year", data);
  },
  deleteReserv(id) {
    return Api().delete(dormpath + "admin/reservations", {
      params: {
        resvid: id
      }
    });
  },
  getBuildAll() {
    return Api().get(dormpath + "admin/buildings");
  },
  getBuildAllByType(e) {
    return Api().get(dormpath + "admin/buildings/buildingstype" + e);
  },
  getReserved(e) {
    return Api().get(dormpath + "admin/reserved" + e);
  },
  postReserved(data) {
    return Api().post(dormpath + "admin/reserved", data);
  },
  deleteReserved(id) {
    return Api().delete(dormpath + "admin/reserved", {
      params: {
        stu: id.stu,
        a: id.a,
        s: id.s
      }
    });
  },
  getBuildAllByRoom(e) {
    return Api().get(dormpath + "admin/buildings/rooms" + e);
  },
  putBuildAllByRoom(data) {
    return Api().put(dormpath + "admin/buildings/rooms", data);
  },
  getBuildAllByRandom(e) {
    return Api().get(dormpath + "admin/buildings/random" + e);
  },
*/


}
